<div class="container mt-5 mb-5">
  <div class="row justify-content-center">
    <div class="col-md-8">
      <div class="mb-4">
        <a routerLink="/home">&larr; Back to Home</a>
      </div>
      <h2 class="mb-4">Privacy Policy</h2>

      <p><strong>Effective Date:</strong> August 2, 2025</p>

      <p>
        Your privacy is important to us. This Privacy Policy explains how
        FlashDrivePrices.com collects, uses, and protects your information.
      </p>

      <h3 class="mt-4">1. Information We Collect</h3>
      <p>
        We do not collect any personally identifiable information (PII) such
        as your name, address, or email. Our site is designed for browsing
        and comparison without requiring user registration.
      </p>

      <h3 class="mt-4">2. Non-Personal Information</h3>
      <p>
        We may collect non-personal information about your visit, such as
        your browser type, operating system, and the pages you view on our
        site. This data is used in an aggregated form to analyze site
        -            traffic and improve our user experience.
      </p>

      <h3 class="mt-4">3. Cookies and Affiliate Links</h3>
      <p>
        We do not use tracking cookies for our own purposes. However, as a
        participant in the Amazon Services LLC Associates Program, when you
        click on an affiliate link to Amazon.com, they may place a cookie
        on your browser to track the referral from our site. This is
        standard practice for affiliate programs and helps support our
        site. For more information, please refer to Amazon's Privacy
        Notice.
      </p>

      <h3 class="mt-4">4. Third-Party Links</h3>
      <p>
        Our website contains affiliate links to Amazon.com. We are not
        responsible for the privacy practices or the content of third-party
        websites. We encourage you to read the privacy policies of any
        website you visit.
      </p>

      <h3 class="mt-4">5. Changes to This Policy</h3>
      <p>
        We may update this Privacy Policy from time to time. Any changes
        will be posted on this page with an updated effective date.
      </p>
    </div>
  </div>
</div>
